import { WebWorker } from "../../workers";
import { IService, IServiceMessage, ServiceStates, ServiceWorkers } from "../interfaces";


export default class Service implements IService {
    name: ServiceWorkers;
    state: ServiceStates;
    start: () => void;
    stop: () => void;
    sendMessageToWorker: (message: IServiceMessage) => void;
    log: () => void;
    report: () => void;
    createdAt: Date | null = null;
    startedAt: Date | null = null;
    stoppedAt: Date | null = null;
    lastRun: Date | null = null;
    lastCommand = null;
    lastCommandTime: Date | null = null;
    lastCommandResult: any | null = null;
    error: Error | null = null;
    worker: WebWorker;

    constructor({
        name,
        start,
        stop,
        sendMessageToWorker: sendMessage,
        log,
        report,
        worker,
        state,
        createdAt,
        error,
        startedAt,
        stoppedAt,
    }: IService) {
        this.name = name;
        this.start = start;
        this.stop = stop;
        this.sendMessageToWorker = sendMessage;
        this.log = log;
        this.report = report;
        this.worker = worker;
        this.state = state;
        this.createdAt = createdAt;
        this.error = error;
        this.startedAt = startedAt;
        this.stoppedAt = stoppedAt;
    }
}
